"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideNotifications = exports.onUserEmailSupplied = exports.showConversation = exports.showTicket = exports.startChecklist = exports.startSurvey = exports.showNews = exports.showArticle = exports.startTour = exports.whoami = exports.getVisitorId = exports.trackEvent = exports.onUnreadCountChange = exports.onShow = exports.onHide = exports.showNewMessage = exports.showMessages = exports.showSpace = exports.show = exports.hide = exports.update = exports.shutdown = exports.boot = exports.Intercom = void 0;
const constants_1 = require("./constants");
const instance_manager_1 = require("./instance-manager");
const callIntercomMethod = (method, ...args) => {
  // window is undefined on server-side and this breaks our widget
  if (typeof window !== undefined && window.Intercom) {
    return window.Intercom(method, ...args);
  } else {
    console.warn("Please ensure Intercom is setup and running on client-side!");
  }
};
const Intercom = props => {
  if (typeof props !== "object") {
    console.warn("Intercom initialiser called with invalid parameters.");
    return;
  }
  const {
      region = "us",
      widgetUrl
    } = props,
    args = __rest(props, ["region", "widgetUrl"]);
  if (typeof window !== "undefined" && !instance_manager_1.ref) {
    window.intercomSettings = Object.assign(Object.assign({}, args), {
      api_base: constants_1.regionAPIs.get(region)
    });
    (0, instance_manager_1.init)({
      widgetUrl
    });
  }
};
exports.Intercom = Intercom;
// Public functions that can be called from outside the module
exports.default = exports.Intercom;
const boot = arg => callIntercomMethod("boot", arg);
exports.boot = boot;
const shutdown = () => callIntercomMethod("shutdown");
exports.shutdown = shutdown;
const update = arg => callIntercomMethod("update", arg);
exports.update = update;
const hide = () => callIntercomMethod("hide");
exports.hide = hide;
const show = () => callIntercomMethod("show");
exports.show = show;
const showSpace = spaceName => callIntercomMethod("showSpace", spaceName);
exports.showSpace = showSpace;
const showMessages = () => callIntercomMethod("showMessages");
exports.showMessages = showMessages;
const showNewMessage = prePopulatedContent => callIntercomMethod("showNewMessage", prePopulatedContent);
exports.showNewMessage = showNewMessage;
const onHide = callback => callIntercomMethod("onHide", callback);
exports.onHide = onHide;
const onShow = callback => callIntercomMethod("onShow", callback);
exports.onShow = onShow;
const onUnreadCountChange = callback => callIntercomMethod("onUnreadCountChange", callback);
exports.onUnreadCountChange = onUnreadCountChange;
const trackEvent = (...args) => callIntercomMethod("trackEvent", ...args);
exports.trackEvent = trackEvent;
const getVisitorId = () => callIntercomMethod("getVisitorId");
exports.getVisitorId = getVisitorId;
const whoami = () => callIntercomMethod("whoami");
exports.whoami = whoami;
const startTour = tourId => callIntercomMethod("startTour", tourId);
exports.startTour = startTour;
const showArticle = articleId => callIntercomMethod("showArticle", articleId);
exports.showArticle = showArticle;
const showNews = newsItemId => callIntercomMethod("showNews", newsItemId);
exports.showNews = showNews;
const startSurvey = surveyId => callIntercomMethod("startSurvey", surveyId);
exports.startSurvey = startSurvey;
const startChecklist = checklistId => callIntercomMethod("startChecklist", checklistId);
exports.startChecklist = startChecklist;
const showTicket = ticketId => callIntercomMethod("showTicket", ticketId);
exports.showTicket = showTicket;
const showConversation = conversationId => callIntercomMethod("showConversation", conversationId);
exports.showConversation = showConversation;
const onUserEmailSupplied = callback => callIntercomMethod("onUserEmailSupplied", callback);
exports.onUserEmailSupplied = onUserEmailSupplied;
const hideNotifications = hidden => callIntercomMethod("hideNotifications", hidden);
exports.hideNotifications = hideNotifications;